;(function($){

	  $(function(){

	  	if( $('.teaserslider-wrapper').length > 0 ){



		  		// tiny helper function to add breakpoints
				function getGridSize() {
					return (window.innerWidth < 768) ? 1 : 3;
				}


				 window.addCurrentSlidesClassTeaserslider = function (slider) {
				    //debugger;
				    $('.teaserslider-wrapper li').removeClass("active-slides");
				    var startli = (slider.move * (slider.currentSlide));
				    var endli = (slider.move * (slider.currentSlide + 1));
				    for (i = startli + 1; i <= endli; i++) {
				        $('.teaserslider-wrapper li:nth-child(' + i + ')').addClass('active-slides');
				    }
				}

				// BITV/WCAG: Fix ARIA roles for auto-generated FlexSlider navigation controls
				function fixTeasersliderAriaRoles(slider) {
					$('.teaserslider-wrapper').each(function() {
						var $wrapper = $(this);
						var $nav = $wrapper.find('.flex-control-nav');
						
						if ($nav.length > 0) {
							// Set role="group" on the ol/ul
							$nav.attr('role', 'group').attr('aria-label', 'Bildauswahl');
							
							// Update buttons/links inside li
							$nav.find('li a').each(function(index) {
								var $link = $(this);
								var currentSlide = slider.currentSlide || 0;
								
								// Add role="button" if not present
								if (!$link.attr('role')) {
									$link.attr('role', 'button');
								}
								
								// Update aria-current
								if ($link.hasClass('flex-active') || index === currentSlide) {
									$link.attr('aria-current', 'page');
								} else {
									$link.attr('aria-current', 'false');
								}
							});
						}
					});
				}

				function show_hide_nav(){
		            $('.teaserslider-wrapper').each(function(){
		            	var $wrapper = $(this);
		            	var slideCount = $wrapper.find('ul.slides > li.slide').length;
		            	var $directionNav = $wrapper.find('.flex-direction-nav');

		            	if (window.innerWidth < 768) {
		            		// Mobile: bullets only (handled via CSS)
		            		$directionNav.hide();
		            	} else if (slideCount > 3) {
		            		// Desktop: arrows only when more than 3 slides
		            		$directionNav.show();
		            	} else {
		            		$directionNav.hide();
		            	}
		            });
	            }

	            $('.teaserslider-wrapper').flexslider({
	              animation: "slide",
	              animationLoop: false,
	              slideshow: false,
	              controlNav: true,
	              directionNav: true,
	              itemWidth: 332,
	              itemMargin: 15,
	              minItems: getGridSize(),
    			  maxItems: getGridSize(),
    			  start: function(slider) { // Fires when the slider loads the first slide
    			  	// BITV/WCAG: Fix ARIA roles for auto-generated navigation controls
    			  	fixTeasersliderAriaRoles(slider);
    			  	show_hide_nav();
	                //var slide_count = slider.count - 1;
	                //$(slider)
	                //    .find('img.lazy:nth-child(-n+3)')
	                //    .each(function() {
	                //      var src = $(this).attr('data-src');
	                //      $(this).attr('src', src).removeAttr('data-src');
	                //    });
	                    window.addCurrentSlidesClassTeaserslider(slider);
	               },
	               before: function(slider) { // Fires asynchronously with each slider animation
//	                  var slides     = slider.slides,
//	                      index      = slider.animatingTo,
//	                      $slide     = $(slides[index]),
//	                      $img       = $slide.find('img[data-src]'),
//	                      current    = index,
//	                      nxt_slide  = current + 1,
//	                      prev_slide = current - 1;
//
//	                  $slide
//	                    .parent()
//	                    .find('img.lazy:eq(' + current + '), img.lazy:eq(' + prev_slide + '), img.lazy:eq(' + nxt_slide + ')')
//	                    .each(function() {
//	                      var src = $(this).attr('data-src');
//	                      $(this).attr('src', src).removeAttr('data-src');
//	                    });
	               },
	               after: function(slider){
	               		// BITV/WCAG: Update ARIA roles after slide change
	               		fixTeasersliderAriaRoles(slider);
	               		window.addCurrentSlidesClassTeaserslider(slider);
	               }
	            });



	            //responsive Flexslider
				var resizeTimer = false;

				$(window).on('resize', function(e) {

				  if( !resizeTimer ) {
					$(window).trigger('resizestart');  	
				  }

				  clearTimeout(resizeTimer);
				  resizeTimer = setTimeout(function() {

					resizeTimer = false;
					$(window).trigger('resizeend');
				            
				  }, 1250);

				}).on('resizestart', function(){
					// console.log('Started resizing the window');
				}).on('resizeend', function(){
					show_hide_nav();

//					$('.teaserslider-wrapper').removeData('flexslider');
//					$('.teaserslider-wrapper').find('.flex-direction-nav').remove();
//					$('.teaserslider-wrapper').find('.flex-control-nav').remove();
//					$('.teaserslider-wrapper').flexslider({
//		              animation: "slide",
//		              animationLoop: false,
//		              slideshow: false,
//		              controlNav: true,
//		              directionNav: true,
//		              itemWidth: 332,
//		              itemMargin: 15,
//		              minItems: getGridSize(),
//	    			  maxItems: getGridSize(),
//	    			  start: function(slider) { // Fires when the slider loads the first slide
//		                //var slide_count = slider.count - 1;
//		                //$(slider)
//		                //    .find('img.lazy:nth-child(-n+3)')
//		                //    .each(function() {
//		                //      var src = $(this).attr('data-src');
//		                //      $(this).attr('src', src).removeAttr('data-src');
//		                //    });
//		                    window.addCurrentSlidesClassTeaserslider(slider);
//		               },
//		               before: function(slider) { // Fires asynchronously with each slider animation
////		                  var slides     = slider.slides,
////		                      index      = slider.animatingTo,
////		                      $slide     = $(slides[index]),
////		                      $img       = $slide.find('img[data-src]'),
////		                      current    = index,
////		                      nxt_slide  = current + 1,
////		                      prev_slide = current - 1;
////
////		                  $slide
////		                    .parent()
////		                    .find('img.lazy:eq(' + current + '), img.lazy:eq(' + prev_slide + '), img.lazy:eq(' + nxt_slide + ')')
////		                    .each(function() {
////		                      var src = $(this).attr('data-src');
////		                      $(this).attr('src', src).removeAttr('data-src');
////		                    });
//		               },
//		               after: function(slider){
//		               		window.addCurrentSlidesClassTeaserslider(slider);
//		               }
//		            });
//
//		            show_hide_nav();
				});





				$('.teasersliderLightbox').on('click',function(e){
					e.preventDefault();

					$(this).colorbox({inline:true, className: 'teasersliderLightboxWrapper', maxWidth: '80%', href: $(this).parent().find('.lightboxContent > div')});
				});

	     
	  	}

	  });
})(jQuery);